/**
 * @flow
 * @relayHash 28908c0853fef79eb174590508e1f6a9
 */

/* eslint-disable */

"use strict";

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MessageSubscriptionVariables = {||};
export type MessageSubscriptionResponse = {|
  +messageSubscription: ?{|
    +action: ?string,
    +users: ?$ReadOnlyArray<?number>,
    +messageId: ?string,
    +message: ?{|
      +sender: {|
        +displayName: ?string
      |},
      +body: string,
      +createdAt: any,
      +expireDate: any,
      +sentToAll: boolean,
      +receivers: {|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +firstName: string,
            +lastName: string,
          |}
        |}>
      |},
    |},
  |}
|};
export type MessageSubscription = {|
  variables: MessageSubscriptionVariables,
  response: MessageSubscriptionResponse,
|};
*/

/*
subscription MessageSubscription {
  messageSubscription {
    action
    users
    messageId
    message {
      sender {
        displayName
        id
      }
      body
      createdAt
      expireDate
      sentToAll
      receivers {
        edges {
          node {
            id
            firstName
            lastName
          }
        }
      }
      id
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function () {
  var v0 = {
      kind: "ScalarField",
      alias: null,
      name: "action",
      args: null,
      storageKey: null,
    },
    v1 = {
      kind: "ScalarField",
      alias: null,
      name: "users",
      args: null,
      storageKey: null,
    },
    v2 = {
      kind: "ScalarField",
      alias: null,
      name: "messageId",
      args: null,
      storageKey: null,
    },
    v3 = {
      kind: "ScalarField",
      alias: null,
      name: "displayName",
      args: null,
      storageKey: null,
    },
    v4 = {
      kind: "ScalarField",
      alias: null,
      name: "body",
      args: null,
      storageKey: null,
    },
    v5 = {
      kind: "ScalarField",
      alias: null,
      name: "createdAt",
      args: null,
      storageKey: null,
    },
    v6 = {
      kind: "ScalarField",
      alias: null,
      name: "expireDate",
      args: null,
      storageKey: null,
    },
    v7 = {
      kind: "ScalarField",
      alias: null,
      name: "sentToAll",
      args: null,
      storageKey: null,
    },
    v8 = {
      kind: "ScalarField",
      alias: null,
      name: "id",
      args: null,
      storageKey: null,
    },
    v9 = {
      kind: "LinkedField",
      alias: null,
      name: "receivers",
      storageKey: null,
      args: null,
      concreteType: "UserTypeConnection",
      plural: false,
      selections: [
        {
          kind: "LinkedField",
          alias: null,
          name: "edges",
          storageKey: null,
          args: null,
          concreteType: "UserTypeEdge",
          plural: true,
          selections: [
            {
              kind: "LinkedField",
              alias: null,
              name: "node",
              storageKey: null,
              args: null,
              concreteType: "UserType",
              plural: false,
              selections: [
                v8,
                {
                  kind: "ScalarField",
                  alias: null,
                  name: "firstName",
                  args: null,
                  storageKey: null,
                },
                {
                  kind: "ScalarField",
                  alias: null,
                  name: "lastName",
                  args: null,
                  storageKey: null,
                },
              ],
            },
          ],
        },
      ],
    };
  return {
    kind: "Request",
    operationKind: "subscription",
    name: "MessageSubscription",
    id: null,
    text:
      "subscription MessageSubscription {\n  messageSubscription {\n    action\n    users\n    messageId\n    message {\n      sender {\n        displayName\n        id\n      }\n      body\n      createdAt\n      expireDate\n      sentToAll\n      receivers {\n        edges {\n          node {\n            id\n            firstName\n            lastName\n          }\n        }\n      }\n      id\n    }\n  }\n}\n",
    metadata: {},
    fragment: {
      kind: "Fragment",
      name: "MessageSubscription",
      type: "Subscription",
      metadata: null,
      argumentDefinitions: [],
      selections: [
        {
          kind: "LinkedField",
          alias: null,
          name: "messageSubscription",
          storageKey: null,
          args: null,
          concreteType: "MessageSubscription",
          plural: false,
          selections: [
            v0,
            v1,
            v2,
            {
              kind: "LinkedField",
              alias: null,
              name: "message",
              storageKey: null,
              args: null,
              concreteType: "MessageType",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "sender",
                  storageKey: null,
                  args: null,
                  concreteType: "UserType",
                  plural: false,
                  selections: [v3],
                },
                v4,
                v5,
                v6,
                v7,
                v9,
              ],
            },
          ],
        },
      ],
    },
    operation: {
      kind: "Operation",
      name: "MessageSubscription",
      argumentDefinitions: [],
      selections: [
        {
          kind: "LinkedField",
          alias: null,
          name: "messageSubscription",
          storageKey: null,
          args: null,
          concreteType: "MessageSubscription",
          plural: false,
          selections: [
            v0,
            v1,
            v2,
            {
              kind: "LinkedField",
              alias: null,
              name: "message",
              storageKey: null,
              args: null,
              concreteType: "MessageType",
              plural: false,
              selections: [
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "sender",
                  storageKey: null,
                  args: null,
                  concreteType: "UserType",
                  plural: false,
                  selections: [v3, v8],
                },
                v4,
                v5,
                v6,
                v7,
                v9,
                v8,
              ],
            },
          ],
        },
      ],
    },
  };
})();
// prettier-ignore
(node/*: any*/).hash = '3bf895dc2cddf0a0f5f236e0c745ab67';
module.exports = node;



// WEBPACK FOOTER //
// ./src/subscriptions/__generated__/MessageSubscription.graphql.js